import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { setToken, removeToken, getToken } from '../utils/auth'
import { setUserInfo, removeUserInfo, getUserInfo } from '../utils/user'
import { authApi } from '../services/api'

// 初始状态
const initialState = {
  token: getToken(),
  user: getUserInfo(),
  loading: false,
  error: null
}

// 登录 thunk
export const login = createAsyncThunk(
  'auth/login',
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await authApi.login(credentials.username, credentials.password)
      console.log('1111111111')
      console.log(response)

      if (response.code === 0) {
        const errorMsg = response.msg || 'Login failed'
        return rejectWithValue(errorMsg)
      }
      
      const { token } = response.data
      
      setToken(token)
      setUserInfo(response.data)
      
      return { token, user: response.data }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Login failed')
    }
  }
)

// 退出登录 thunk
export const logout = createAsyncThunk(
  'auth/logout',
  async () => {
    const response = await authApi.logout()
    if (response.code === 200) {
      removeToken()
      removeUserInfo()
      return null
    }
    return null
  }
)

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // 登录状态处理
      .addCase(login.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(login.fulfilled, (state, action) => {
        state.token = action.payload.token
        state.user = action.payload.user
        state.loading = false
        state.error = null
      })
      .addCase(login.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      // 退出登录状态处理
      .addCase(logout.fulfilled, (state) => {
        state.token = null
        state.user = null
        state.error = null
      })
  },
})

export default authSlice.reducer 